import ElementPlus from 'element-plus'
// import '../element-variables.scss'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default (app) => {
  app.use(ElementPlus, { zhCn })
}
